import React, { CSSProperties } from 'react';

const DisabledOverlay = () => {
	const style: CSSProperties = {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
		height: '100%',
		position: 'absolute',
		backgroundColor: 'rgba(107, 116, 127, 0.2)',
		top: '0',
		left: '0',
		zIndex: 10,
	};

	return <div style={style} />;
};

export default DisabledOverlay;
